import moment from 'moment';
import React, { useMemo, useState } from 'react';
import Accordion from '../../components/accordion';
import { BtnComponent } from '../../components/button';
import { useGroupChatContext } from '../../context/groupchatContext';
import { DatePickerFeild } from '../../components/reactHookFormFields/datePicker';
import { useForm, useWatch } from 'react-hook-form';
import { ReactSelectField } from '../../components/reactHookFormFields/selectField';
import { InputField } from '../../components/reactHookFormFields/inputField';
import { useGetEncounterSettingsQuery } from '../../services/chatService';
import { toast } from 'react-toastify';


const EncounterFilter = React.memo(({ setFilters,isLoading }) => {

    const groupChatContext = useGroupChatContext();
    const {selectedChat} = useMemo(() => ({
        selectedChat: groupChatContext.selectedChat,
    }));

    const {
        control,
        formState: { errors },
        reset,
        getValues,
    } = useForm();

    const {data: encounterSetting} = useGetEncounterSettingsQuery({pid: selectedChat.pid, case: 'all'});
    const watchedFromDate = useWatch({ control, name: 'from_date' });
    const watchedToDate = useWatch({ control, name: 'to_date' });
    const selectedEncounterType = useWatch({ control, name: 'encounter_types' });
    const filteredTemplates = encounterSetting?.encounter_templates?.filter(
        template => template.encounter_type === selectedEncounterType?.slug
    );

    const handleReset = () => {
        reset({
            encounter_id: "",
            case: null,
            providers: null,
            visit_reasons: null,
            encounter_types: null,
            note_template: null
        });
        setFilters({}); 
    };
    const handleSearch = () => {
        const formData = getValues();
        if (formData?.to_date && !formData?.from_date) {
            toast.error("Start Date is required when End Date is selected.");
            return;
        }
        const params = {
            from_date: formData?.from_date,
            to_date: formData?.to_date,
            case_id: formData?.case?.id,
            provider_id: formData?.providers?.id,
            visit_reason: formData?.visit_reasons?.slug,
            serial_number: formData?.encounter_id,
            template: formData?.note_template?.slug,
            encounter_types: formData?.encounter_types?.slug
        }
        setFilters(params);
    };

    return (
        <Accordion title="Filters" open={true}>
            <div className="pt-4 pb-2">
                <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 gap-3 lg:gap-4 pb-3 w-full">
                    <div className="min-w-0">
                        <DatePickerFeild
                            title="Start Date"
                            control={control}
                            name="from_date"
                            dateTime={false}
                            maxDate={watchedToDate || new Date()}
                            errors={errors}
                        />
                    </div>
                    <div className="min-w-0">
                        <DatePickerFeild
                            title="End Date"
                            control={control}
                            name="to_date"
                            dateTime={false}
                            errors={errors}
                            minDate={watchedFromDate}
                            maxDate={new Date()}
                        />
                    </div>
                    <div className="min-w-0">
                        <InputField
                            title="Encounter ID"
                            name="encounter_id"
                            control={control}
                        />
                    </div>
                    <div className="min-w-0">
                        <ReactSelectField
                            title="Case"
                            name="case"
                            control={control}
                            optionData={encounterSetting?.case_types?.map((v, k) => ({
                                ...v,
                                label: v.title,
                            }))}
                            errors={errors}
                        />
                    </div>
                    <div className="min-w-0">
                        <ReactSelectField
                            title="Providers"
                            name="providers"
                            control={control}
                            optionData={encounterSetting?.provider_list?.map((v, k) => ({
                                ...v,
                                label: `${v.title} ${v.name} ${v.suffix}`,
                            }))}
                            errors={errors}
                        />
                    </div>
                    <div className="min-w-0">
                        <ReactSelectField
                            title="Visit Reasons"
                            name="visit_reasons"
                            control={control}
                            optionData={encounterSetting?.visit_reasons?.map((v, k) => ({
                                ...v,
                                label: v.title,
                            }))}
                            errors={errors}
                        />
                    </div>
                    <div className="min-w-0">
                        <ReactSelectField
                            title="Encounter Type"
                            name="encounter_types"
                            control={control}
                            optionData={encounterSetting?.encounter_types?.map((v, k) => ({
                                ...v,
                                label: v.type,
                            }))}
                            errors={errors}
                        />
                    </div>
                    <div className="min-w-0">
                        <ReactSelectField
                            title="Note Template"
                            name="note_template"
                            control={control}
                            optionData={filteredTemplates?.map((v, k) => ({
                                ...v,
                                label: v.title,
                            }))}
                            errors={errors}
                        />
                    </div>
                    <div className="grid grid-cols-2 sm:grid-cols-2 gap-2 pb-3 w-full">
                        <BtnComponent text="Search" btnType="primary" onClick={handleSearch} />
                        <BtnComponent text="Reset" btnType="chief" onClick={handleReset} />
                    </div>
                </div>
            </div>
        </Accordion>
    )
})

export default EncounterFilter;